export default {
  /* If dev mode and Base URL is not specified then use the default value else use the Base URL env variable */
  siteURL: process.env.VUE_APP_API_BASE_URL,
  msgURL: process.env.VUE_APP_API_MSG_URL,
  ghostURL: process.env.VUE_APP_API_GHOST_URL,
  ghostKey: process.env.VUE_APP_API_GHOST_API_KEY,
}
